import * as s from "./Knob.css";

interface KnobProps {
  ariaLabel: string;
  onClick: () => void;
  selected: boolean;
}

export const Knob = ({ ariaLabel, onClick, selected }: KnobProps) => {
  return (
    <button
      aria-checked="false"
      aria-label={ariaLabel}
      className={`${s.Track} ${selected ? s.TrackOn : ""}`}
      id=":rgi:"
      onClick={onClick}
      role="switch"
      type="button"
    >
      <div className={`${s.Knob} ${selected ? s.KnobOn : ""}`}></div>
    </button>
  );
};
